import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from '../Onboarding.module.scss';

const InnerStepTwo: React.FC = () => {
	return (
		<>
			<div className={styles['heading']}>
				<img
					className={styles['svg']}
					src="/assets/onboarding-icons/search.svg"
				/>
				Find better songs
			</div>
			<div className={classNames([styles['text'], 'mt-sm'])}>
				Search by city, denomination, and more. Discover what works for
				churches like yours.
			</div>
		</>
	);
};

export default InnerStepTwo;
